import { adminRpcClient } from '@/providers/backendClient';
import { Check as CheckIcon } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';

export type TranscribeAllPendingProps = {
  assetId: string;
  assetType: string;
  recordings: any[];
  refreshRecordings: () => void;
};

const statusSet = new Set(['uploaded', 'transcribing']);

export const TranscribeAllPendingButton = ({
  assetId,
  assetType,
  recordings,
  refreshRecordings,
}: TranscribeAllPendingProps) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const onForceTranscription = useCallback(async () => {
    setIsUpdating(true);

    const result = (await adminRpcClient(
      'PUBLIC_ADMIN_therapistRecordings_transcribeAllPending',
      [assetId, assetType],
    ).catch(err => {
      alert(
        'Error transcribing all pending recordings: ' + err.message,
      );

      return { error: err.message };
    })) as any;

    refreshRecordings();

    setIsUpdating(false);

    if (result.error) {
      alert(
        'Error transcribing all pending recordings: ' + result.error,
      );
    }

    console.log(result);
  }, [assetId, assetType, refreshRecordings]);

  const hasPendingTranscriptions = useMemo(
    () => (recordings || []).some(rec => statusSet.has(rec.status)),
    [recordings],
  );

  if (!hasPendingTranscriptions) {
    return null;
  }

  return (
    <Button
      disabled={isUpdating}
      onClick={onForceTranscription}
      startIcon={
        !isUpdating ? <CheckIcon /> : <CircularProgress size="1rem" />
      }
    >
      {!isUpdating ? 'Retry Transcription' : 'Transcribing'}
    </Button>
  );
};
